export default "__VITE_ASSET__BpcGslEb__"